<template>
  <div class="product-card" @click="selectProd()" v-show="showCard === true">
    <Product
      :product="item"
      :originalProduct="item"
      :withImage="true"
      :productActionsCentered="true"
      :showBrand="true"
      :showShowroomPrice="true"
      :withDescription="true"
      :designName="designName"
    />
  </div>
</template>

<script>
import Product from "@/components/Projects/Product/Product";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "CatalogueProductCard",

  computed: {
    ...mapState("threekit", ["cachedTKData"]),
    ...mapGetters("showroom", ["color1", "color2", "color3"]),

    threekitDesignItem() {
      return this.item.threekit_designs?.length
        ? this.item.threekit_designs[0]
        : null;
    },

    designName() {
      return this.threekitDesignItem?.design_name;
    },

    showCard() {
      if (!this.allFilters) return false;
      let show = true,
        found = false;

      const filterKeys = Object.keys(this.allFilters);
      for (let index = 0; index < filterKeys.length; index++) {
        const filterKey = filterKeys[index];
        const filter = this.allFilters[filterKey];
        const filterName = filterKey.replace("filter", "").toLowerCase();

        //loop inside filter keys

        found = false;
        for (let filterIndex = 0; filterIndex < filter.length; filterIndex++) {
          const filterKey = filter[filterIndex];

          if (filterKey.name === this.item[filterName] && filterKey.checked) {
            found = true;
          }
        }
        if (!found) {
          show = false;
        }
      }
      return show;
    },
  },

  props: {
    item: {
      type: Object,
    },
    allFilters: {},
  },

  components: {
    Product,
  },

  methods: {
    ...mapActions("project", [
      "goToActiveProductPage",
      "updateDecorationsForProjectProductsLayouts",
    ]),
    ...mapActions("threekit", ["initProductCache"]),

    async initThreekit() {
      const designName = this.threekitDesignItem
        ? this.threekitDesignItem?.design_name
        : null;

      await this.initProductCache({
        styleName: this.item.style_id,
        designName:
          designName != null && designName.length
            ? designName.toUpperCase()
            : null,
      });
      //}
    },

    selectProd() {
      let prod = this.item
      prod.designName = this.threekitDesignItem?.design_name,
      this.goToActiveProductPage(prod);
    },
  },

  mounted() {
    this.initThreekit();
    this.updateDecorationsForProjectProductsLayouts();
  },
};
</script>

<style lang="scss" scoped>
#app {
  .product-card {
    position: relative;
    display: flex;
    justify-content: center;
    width: 300px;
    border: 1px solid #f4f4f5;
    height: 480px;
    cursor: pointer;
    .product-customize-actions {
      display: flex;
      visibility: hidden;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      justify-content: center;
      align-items: center;
      z-index: 1;
      .product-customize-action {
        cursor: pointer;
        background-color: #26262c;
        padding: 5px 20px;
        > span {
          margin-left: 5px;
          color: white;
        }
      }
    }
    &:hover {
      background: #f9fafa;
      .product-customize-action {
        visibility: visible;
      }
    }

    ::v-deep .product-preview {
      height: 60%;
    }
    ::v-deep .product-display {
      height: 100%;
    }
    ::v-deep .spinner-loader-container {
      margin: auto;
    }

    ::v-deep .product-info {
      padding: 0.85rem 1.75rem !important;
      border-top: 1px solid $grey-lighter;
      height: 40%;
      .grid-title {
        font-size: 1.2rem;
        margin-bottom: 0.1rem !important;
        text-align: start;
      }

      .product-description-list {
        margin-left: 0.5em !important;

        li {
          color: $grey-dark;
          span {
            font-size: 1rem !important;
            color: $grey-dark;
            line-height: 0.95rem !important;
          }
        }
      }
    }
  }
}
</style>
